export default __webpack_public_path__ + "static/media/bo-katan-001.7d0710d4.jpg";